<template>
  <div>
    <vs-card>
      <div style="display: flex">
        <div>
          <img
            src="@/assets/images/d-net/device.png"
            alt="device"
            height="150"
          />
        </div>
        <div
          style="
            display: flex;
            width: 100%;
            justify-content: space-around;
            flex-direction: column;
          "
        >
          <div
            style="display: flex; width: 100%; justify-content: space-around"
          >
            <div
              style="display: flex; width: 100%; 
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            }"
            >
              <h2 style="font-weight: bold">Temperature</h2>
              <div style="font-weight: bold; font-size: 2.5em">
                {{ temp }} °C
              </div>
            </div>

            <div
              style="display: flex; width: 100%; 
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            }"
            >
              <h2 style="font-weight: bold">Humidity</h2>
              <div style="font-weight: bold; font-size: 2.5em">
                {{ humid }} %
              </div>
            </div>
          </div>
          <div
            style="display: flex; width: 100%; 
            align-items: center;
            justify-content: flex-end;
            gap:10px;
            }"
          >
            <div
              style="display: flex; width: 100%; 
            align-items: center;
            gap:10px;
            justify-content: flex-end;
            }"
            >
              <span style="font-weight: bold">battery</span>
              <span style="font-weight: bold; font-size: 1em">
                {{ battery }} %
              </span>
            </div>
          </div>
        </div>
      </div>
    </vs-card>
    <vs-card>
      <vs-row>
        <div></div>
        <!-- <vs-select width="150px" v-model="select_temp">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in options1"
          /> </vs-select
        ><vs-spacer /> -->
        <!-- <vs-select width="150px" v-model="select_duration">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in options2"
          /> </vs-select> --> </vs-row
      ><br />
      <div style="position: relative; width: 100%">
        <line-chart
          :height="200"
          :chartdata="chartData"
          :options="optionsChart"
          :areaColors="['#007bff', '#b38dff']"
          :heightChart="200"
        />
      </div>
      <vs-row style="align-items: center">
        <div
          style="
            width: 6.5%;
            border-radius: 20px;
            height: 2%;
            background-color: #4dc4ff;
            color: #4dc4ff;
          "
        >
          .
        </div>
        <a class="ml-1">Temperature </a>
        <div
          class="ml-2"
          style="
            width: 6.5%;
            border-radius: 20px;
            height: 2%;
            background-color: #b38dff;
            color: #b38dff;
          "
        >
          .
        </div>
        <a class="ml-1">Humidity</a>
        <vs-spacer />
        <div class="mr-4">
          <p style="color: #fc8200" class="mb-1">avg</p>
          <p>{{ avg.toFixed(2) }} °C</p>
        </div>
        <div class="mr-4">
          <p style="color: #ff006a" class="mb-1">min</p>
          <p>{{ min.toFixed(2) }} °C</p>
        </div>
        <div class="mr-4">
          <p style="color: #d400ff" class="mb-1">max</p>
          <p>{{ max.toFixed(2) }} °C</p>
        </div>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import LineChart from "@/components/ChartJs/LineChart.vue";
export default {
  components: { LineChart },
  data() {
    return {
      temp: 0,
      humid: 0,
      battery: 0,
      mac: "",
      select_duration: 1,
      options2: [
        { text: "1 Day", value: 1 },
        { text: "2 Day", value: 2 },
      ],
      chartData: {
        datasets: [
          {
            data: [22, 19, 22, 11, 16, 11, 10],
            label: "Temperature ( °C )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#007bff",
            //     backgroundColor:  this.gradient,
          },
          {
            data: [10, 14, 13, 15, 11, 24, 18],
            label: "Humid ( % )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#b38dff",

            //     backgroundColor:  this.gradient,
          },
        ],
        labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2 am"],
      },
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                // beginAtZero: true,
                // fontColor: "#ffffff",
                step: 1,
              },
              // position: "left",
              scaleLabel: {
                display: true,
                // labelString: this.chartdata.tooltip_label,
              },
            },
          ],
          // xAxes: [
          //   {
          //     // ticks: {
          //     //   // beginAtZero: true,
          //     //   fontColor: "#ffffff",
          //     // },
          //     // scaleLabel: {
          //     //   // display: true,
          //     //   // labelString: "Timestamp",
          //     // },
          //     type: 'time',
          //   },
          // ],
        },
      },
      max: 0,
      min: 0,
      avg: 0,
      interval_1:null,
      interval_5:null,

    };
  },
  async mounted() {
    await this.getDataTemp();
    await this.getDataTempLog();

    
    
  },
  beforeDestroy(){
    clearTimeout(this.interval_1)
    clearTimeout(this.interval_5)

  },
  methods: {
    async getDataTemp() {
      try {
        let res = await this.$API.get("indoorsensor");
        console.log("indoor sensor", res);
        this.temp = res.data[0].sensordata.temperature;
        this.humid = res.data[0].sensordata.humidity;
        this.battery = res.data[0].sensordata.battery;
        this.mac = res.data[0].mac;
      } catch (error) {}
      this.interval_1 = setTimeout(async() => {
    await this.getDataTemp();
    }, 1000*20);
    },
    async getDataTempLog() {
      try {
        console.log(this.mac);
        let res = await this.$API.get(`indoorsensorlog/${this.mac}`);
        console.log("indoor sensor log", res);
        let dataTemp = [];
        let dataHumid = [];
        let label = [];
        let total = 0;
        this.max = parseFloat(res.data[0].sensordata.temperature);
        this.min = parseFloat(res.data[0].sensordata.temperature);
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          dataTemp.push(el.sensordata.temperature);
          dataHumid.push(el.sensordata.humidity);
          label.push(this.$moment(el.timestamp).format("HH:mm"));
          this.max =
            parseFloat(el.sensordata.temperature) > this.max
              ? parseFloat(el.sensordata.temperature)
              : this.max;
          this.min =
            parseFloat(el.sensordata.temperature) < this.min
              ? parseFloat(el.sensordata.temperature)
              : this.min;
          total += parseFloat(el.sensordata.temperature);
        }
        this.avg = total / res.data.length;
        // console.log(label);
        this.chartData.labels = label;
      this.chartData.datasets[0].data = dataTemp;
      this.chartData.datasets[1].data = dataHumid;

        // this.chartData = {
        //   datasets: [
        //     {
        //       data: dataTemp,
        //       label: "Temperature ( °C )",
        //       pointBorderWidth: 1,
        //       borderWidth: 3,
        //       borderColor: "#007bff",
        //     },
        //     {
        //       data: dataHumid,
        //       label: "Humid ( % )",
        //       pointBorderWidth: 1,
        //       borderWidth: 3,
        //       borderColor: "#b38dff",
        //     },
        //   ],
        //   labels: label,
        // };
      } catch (error) {}
      this.interval_5 = setTimeout(async() => {
    await this.getDataTempLog();
    }, 1000*60*5);
    },
  },
};
</script>

<style>
</style>